import type { QueryKeyData, QueryParams } from '@pba/react-query';
import type { ChatroomDataObject } from '#models/services';
import { useQuery } from '#react-query';
import { getChatroom } from '../../services';
import { getChatroomDetailQueryKey } from './keys';

export type ChatroomsQueryData = QueryKeyData<ChatroomDataObject, typeof getChatroomDetailQueryKey>;

export type GetChatroomParams = QueryParams<ChatroomsQueryData, GetChatroomQueryFilter>;

type GetChatroomQueryFilter = {
  id: string;
};

export const useGetChatroom = ({ filter: { id }, options }: GetChatroomParams) =>
  useQuery({
    async queryFn() {
      const { data } = await getChatroom({ routeParams: { id } });

      return data;
    },
    queryKey: getChatroomDetailQueryKey({ id }),
    ...options,
  });
